/**
 * getAuthors is a function that extracts authors for PostMeta component.
 *
 * @param {Array | Boolean} authors - An array of authors from middleware.
 * @param {Object} brandConfig - The brand configuration object
 *
 * @returns {Object|boolean} - Returns an object containing author details or false if authors is explicitly set to false.
 */
export function getAuthors({
  authors = [] || false,
  brandConfig = {},
}) {
  // If authors is explicitly set to false, the function returns false.
  // This is to prevent the author from being displayed on the page.
  if (authors === false) {
    return false;
  }

  // Default author object, used when authors is undefined, null or an empty array.
  const defaultAuthor = {
    name: `${brandConfig?.name || 'Autovia'} team`,
    url: '',
    image: {
      src: brandConfig?.logo?.src || '/public/logo.png',
    },
  };

  // If authors is undefined, null or an empty array, the function returns the default author in array format.
  if (!authors?.length) {
    return [defaultAuthor];
  }

  // authorsList is an array of authors, limited to three authors.
  const authorsList = authors.slice(0, 3);

  // If the authors array has more than three authors, the last author in the authorsList is replaced with the default author.
  if (authors.length > 3) {
    authorsList.pop();
    authorsList.push(defaultAuthor);
  }

  return authorsList;
}
